import {
  useEffect,
  useMemo,
  useState,
} from "react";
import { Form } from "reactstrap";
import { APIMS } from "../../../../../../config/apims";
import Modal from "react-bootstrap/Modal";
import { useMutation } from "react-query";
import "bulma/css/bulma.css";
import "../../../../../../index.css";
import ToastError from "../../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../../NotificationToast/ToastSuccess";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFloppyDisk,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";

export default function ModalTahunAjaranUpdate(
  props
) {
  const token = localStorage.getItem("token");

  const idUser = localStorage
    .getItem("id_admin")
    ?.replace(/[|&;$%@"<>()+,]/g, "");

  const [form, setForm] = useState({
    name_year: "",
    status: 0,
  });

  const [isSubmitting, setIsSubmitting] =
    useState(false);

  const fetchParams = useMemo(
    () => ({
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    }),
    [token]
  );

  useEffect(() => {
    setForm({
      name_year:
        props?.dataUpdate?.name_year || "",
      status:
        Number(
          props?.dataUpdate?.status
        ) === 1
          ? 1
          : 0,
    });
  }, [props?.dataUpdate]);

  const handleChange = (event) => {
    const { name, value } = event.target;

    setForm((previousForm) => ({
      ...previousForm,
      [name]: value,
    }));
  };

  const handleStatusChange = () => {
    setForm((previousForm) => ({
      ...previousForm,
      status:
        Number(previousForm.status) === 1
          ? 0
          : 1,
    }));
  };

  const updateAcademicYearStatus = async (
    academicYear,
    nextStatus
  ) => {
    return APIMS.put(
      `/api/academic-years/${academicYear.id}`,
      {
        name_year:
          academicYear?.name_year || "",
        status: Number(nextStatus),
        user_id: idUser,
      },
      fetchParams
    );
  };

  const handleSubmit = useMutation(
    async (event) => {
      event.preventDefault();

      if (!form.name_year.trim()) {
        ToastError.fire({
          icon: "error",
          title:
            "Tahun ajaran wajib diisi",
        });

        return;
      }

      setIsSubmitting(true);

      const deactivatedAcademicYears = [];

      try {
        /*
         * Jika data ini akan diaktifkan,
         * nonaktifkan data aktif lainnya.
         */
        if (Number(form.status) === 1) {
          const activeAcademicYears = (
            props?.allAcademicYears || []
          ).filter(
            (item) =>
              item?.id !==
                props?.dataUpdate?.id &&
              Number(item?.status) === 1
          );

          for (const activeItem of activeAcademicYears) {
            await updateAcademicYearStatus(
              activeItem,
              0
            );

            deactivatedAcademicYears.push(
              activeItem
            );
          }
        }

        const response = await APIMS.put(
          `/api/academic-years/${props?.dataUpdate?.id}`,
          {
            name_year:
              form.name_year.trim(),
            status: Number(form.status),
            user_id: idUser,
          },
          fetchParams
        );

        if (response?.status === 200) {
          ToastSuccess.fire({
            icon: "success",
            title: response.data.message,
          });

          await props.GetResponseData();
          props.onHide();
        }
      } catch (error) {
        /*
         * Kembalikan tahun ajaran sebelumnya
         * menjadi aktif jika update gagal.
         */
        if (
          deactivatedAcademicYears.length > 0
        ) {
          await Promise.allSettled(
            deactivatedAcademicYears.map(
              (academicYear) =>
                updateAcademicYearStatus(
                  academicYear,
                  1
                )
            )
          );
        }

        ToastError.fire({
          icon: "error",
          title:
            error.response?.data?.message ||
            "Gagal memperbarui data",
        });
      } finally {
        setIsSubmitting(false);
      }
    }
  );

  const isActive =
    Number(form.status) === 1;

  return (
    <Modal
      {...props}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="sims-modal-dialog"
      contentClassName="sims-modal-content"
      aria-labelledby="modal-update-tahun-ajaran"
    >
      <div className="sims-modal-header">
        <div>
          <h5
            id="modal-update-tahun-ajaran"
            className="sims-modal-title"
          >
            Update Tahun Ajaran
          </h5>
        </div>

        <button
          type="button"
          className="sims-modal-close"
          onClick={props.onHide}
          aria-label="Tutup modal"
          disabled={isSubmitting}
        >
          <FontAwesomeIcon icon={faXmark} />
        </button>
      </div>

      <Form
        onSubmit={(event) =>
          handleSubmit.mutate(event)
        }
      >
        <div className="sims-modal-body">
          <div className="sims-form-grid">
            <div className="sims-form-group sims-form-span-2">
              <label
                className="sims-form-label"
                htmlFor="name_year_update"
              >
                Tahun Ajaran
                <span>*</span>
              </label>

              <input
                id="name_year_update"
                type="text"
                name="name_year"
                className="sims-form-input"
                value={form.name_year}
                onChange={handleChange}
                autoFocus
                autoComplete="off"
                required
                disabled={isSubmitting}
              />
            </div>

            <div className="sims-form-group sims-form-span-2">
              <div className="sims-status-form-card">
                <div className="sims-status-form-info">
                  <span className="sims-status-form-title">
                    Status Tahun Ajaran
                  </span>

                  <span className="sims-status-form-description">
                    Mengaktifkan data ini akan
                    menonaktifkan tahun ajaran
                    aktif sebelumnya.
                  </span>
                </div>

                <div className="sims-status-form-action">
                  <label className="sims-toggle">
                    <input
                      type="checkbox"
                      checked={isActive}
                      onChange={
                        handleStatusChange
                      }
                      disabled={isSubmitting}
                    />

                    <span className="sims-toggle-slider" />
                  </label>

                  <span
                    className={`sims-status-label ${
                      isActive
                        ? "is-active"
                        : "is-inactive"
                    }`}
                  >
                    {isActive
                      ? "Aktif"
                      : "Tidak Aktif"}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="sims-modal-footer">
          <button
            type="button"
            className="sims-modal-cancel"
            onClick={props.onHide}
            disabled={isSubmitting}
          >
            Batal
          </button>

          <button
            type="submit"
            className="sims-modal-submit"
            disabled={
              isSubmitting ||
              !form.name_year.trim()
            }
          >
            {isSubmitting ? (
              <>
                <span className="sims-button-spinner" />
                <span>Memperbarui...</span>
              </>
            ) : (
              <>
                <FontAwesomeIcon
                  icon={faFloppyDisk}
                />

                <span>Perbarui</span>
              </>
            )}
          </button>
        </div>
      </Form>
    </Modal>
  );
}